// Older sessions kept the user's password hash in browser storage. The app no
// longer needs it (the server checks payment passwords), so remove it once.
// Imported before the redux store so persisted state rehydrates without it.
const strip = (user) => {
  if (user && typeof user === "object" && "password" in user) {
    delete user.password;
    return true;
  }
  return false;
};

try {
  const logged = JSON.parse(localStorage.getItem("loggedUser") || "null");
  if (strip(logged?.user)) localStorage.setItem("loggedUser", JSON.stringify(logged));

  const root = JSON.parse(localStorage.getItem("persist:root") || "null");
  if (root?.auth) {
    const auth = JSON.parse(root.auth);
    if (strip(auth?.loggedUser?.user)) {
      root.auth = JSON.stringify(auth);
      localStorage.setItem("persist:root", JSON.stringify(root));
    }
  }
} catch (e) {
  // Storage blocked or malformed: nothing to clean.
}
